export default __webpack_public_path__ + "static/media/DreamCast.b8cd5208.svg";